import dynamic from 'next/dynamic';
import { forwardRef } from 'react';

import ErrorBoundary from 'components/ErrorBoundary';
import GenericError from 'components/GenericError';
import LazyHydration from 'components/LazyHydration';

import useCommentIdFromRouterHash from 'hooks/useCommentIdFromRouterHash';

import placeholder from 'lib/placeholder';

const CommentsList = dynamic(() => import('.'), {
  ssr: false,
});

const DynamicallyLoadedCommentsList = forwardRef(
  ({ articleCommentsCount, articleId, isCommentsAllowed }, ref) => {
    const { isValidCommentIdHashAvailable } = useCommentIdFromRouterHash();

    return (
      <>
        {/* Placeholder div to use its ref instead of
          `OfferComments` components if it is not loaded yet */}
        <div ref={ref} />
        <LazyHydration
          force={isValidCommentIdHashAvailable}
          placeholderSize={{ height: 316, width: 330 }}
        >
          <ErrorBoundary
            fallback={
              <GenericError
                message={placeholder('errors.couldNotLoadLastComments')}
              />
            }
          >
            <CommentsList
              articleCommentsCount={articleCommentsCount}
              articleId={articleId}
              isCommentsAllowed={isCommentsAllowed}
            />
          </ErrorBoundary>
        </LazyHydration>
      </>
    );
  }
);

DynamicallyLoadedCommentsList.displayName =
  'DynamicallyLoadedArticleCommentsWithRef';

export default DynamicallyLoadedCommentsList;
